import PageLayout from '@components/page/PageLayout'
import { Container, Image } from '@mantine/core'
import ERROR404 from '../images/ERROR404.svg'
import ClientHeader from '@components/header/ClientHeader'
const PageNotFound404 = () => {
    return (
        <PageLayout
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}
        >
            <ClientHeader />
            <Container>
                <Image src={ERROR404} />
            </Container>
        </PageLayout>
    )
}
export default PageNotFound404
